import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { StatusService } from '../../services/status.service';
import { Status } from '../../beans/status';

@Component({
	selector: 'app-status',
	templateUrl: './statuses.component.html',
	styleUrls: ['./statuses.component.scss']
})
export class StatusComponent implements OnInit {

	statuses: Status[] = [];

	constructor(
		private statusService: StatusService,
		private vcRef: ViewContainerRef
	) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.statusService.getAll().subscribe(
			r => {
				this.statuses = r;
			},
		);
	}

	addNew() {
		this.statuses.unshift({
			name: '',
			statusReshen: false,
			deklaracijaChlen83: false,
			zavedenaPretencija: false,
			plashtaneDarjavnaTaksa: false,
			zadacha: false,
			arhiven: false,
			sporazumeni: false
		});
	}

	save(s: Status) {
		this.statusService.save(s).subscribe(
			saved => {
				Object.assign(s, saved); // взима id при new
			},

		);
	}
	refresh() {
		this.load();
	}

}
